/**
 * Brand palette. dec-green is a Tailwind-numbered ramp (100-800, 500 = base);
 * orange, yellow, light-blue, blue are single tokens.
 *
 *   dec-green       #028A00   the DEC brand
 *   dec-orange      #ff9d0a
 *   dec-yellow      #ffd60a
 *   dec-light-blue  #32bfec
 *   dec-blue        #326dec   the producer-side accent
 *
 * This file mirrors the `@theme` block in `src/styles/index.css`, that file is the
 * Tailwind v4 config and the source of truth. These literals exist because anime.js
 * interpolates colour keyframes itself and SVG attributes set from JS cannot read
 * `var(--…)`. Keep the two in sync; edit both when a value changes.
 */

export const green = {
  100: "#d5f5d4",
  200: "#6fdc6d",
  300: "#09c206",
  400: "#03ac00",
  500: "#028A00",
  600: "#0c760a",
  700: "#076d05",
  800: "#034d02",
} as const;

/**
 * Neutral ink, Tailwind's zinc scale, mirrored for the same reason as the brand
 * ramps: SVG attributes and canvas fills set from JS cannot read `var(--…)` or a
 * Tailwind class. Not a brand colour; use the `zinc-*` classes in markup.
 */
export const INK = {
  50: "#fafafa",
  100: "#f4f4f5",
  200: "#e4e4e7",
  300: "#d4d4d8",
  400: "#a1a1aa",
  500: "#71717a",
  600: "#52525b",
  700: "#3f3f46",
  900: "#18181b",
} as const;

/* base tones */
export const GREEN = green[500];
export const ORANGE = "#ff9d0a";
export const YELLOW = "#ffd60a";
export const BLUE = "#326dec";

/** Guarantees of Origin, a semantic token, deliberately outside the ramps. */
export const GO = "#7cf07a";

/* legacy aliases → ramp steps, kept so existing imports don't churn */
export const GREEN_LIGHT = green[300];

export type { Tint } from "@/5-shared/types";
